import React, { Component } from "react";
import axios from "axios";

import PostItem from "./PostItem";

export class PostBanners extends Component {
    state = {
        posts: [],
        isLoaded: false,
    };
    
    componentDidMount() {
        axios
        .get("https://obrien365.com/ob-wp/wp-json/wp/v2/posts/")
        .then((res) =>
        this.setState({
            posts: res.data,
            isLoaded: true,
        })
        )
        .catch((err) => console.log(err));
    }

    
    
    render() {
    const { posts, isLoaded } = this.state;
    if (isLoaded) {
        return (
        <div className="App post">
            
            {posts.map(post => (
                //@ts-ignore
                <PostItem key={post.id} post={post} />
            ))}
            
        </div>
        );
    }
    return <div className="loading"><h3>Loading...</h3></div>;
    }
}
export default PostBanners;